module.exports = __webpack_public_path__ + "static/Obraz1-178410775dbeb48dbc237f07349b0b00.png";